module.exports = __webpack_public_path__ + "img/zhihuichengshi.4fc3dcd6.png";